import ic_location from './Recursos/ic_location.svg'
import ic_tel from './Recursos/ic_telefono_azul.svg'
import ic_mail from './Recursos/ic_mail.svg'
import ic_face from './Recursos/ic_face.svg'
import ic_insta from './Recursos/ic_insta.svg'
import ic_tiktok from './Recursos/ic_tiktok.svg'

export const SECCIONES = ['CONTACTOS', 'NOSOTROS', 'TESTIMONIOS', 'ACTIVIDADES']

export const NEGRITA = 'DM Serif Display'

export const WASS = ''


export const CONTACTOS = [
    {
        nombre: 'Direccion',
        img: ic_location,
        descripcion: 'Calle Bolívar con Pedro Arizala, San Andrés de Tumaco',

    },
    {
        nombre: 'Telefono',
        img: ic_tel,
        descripcion: '(57) 316-456-1245',

    },
    {
        nombre: 'Correo',
        img: ic_mail,
        descripcion: 'info@hotelmarazultumaco.com',

    },
]

export const REDES = [
    {
        nombre: 'facebook',
        img: ic_face,
        link: ''
    },
    {
        nombre: 'instagram',
        img: ic_insta,
        link: ''
    },
    {
        nombre: 'tiktok',
        img: ic_tiktok,
        link: ''
    },
]

export const LAT = 1.8049938016522937
export const LONG = -78.76710515388051